import { Injectable, Provider } from '@angular/core';
import { IConfigurationApiService, IConfigurationApiServiceToken } from './configuration-api-service.interface';
import { ConfigurationClient, ConfigurationGetQueryResult } from '../../INTEGRA_Shop_Client';
import { Observable, Observer, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationApiService implements IConfigurationApiService {

  private configurationGetSubscription: Subscription | undefined;

  constructor(
    private configurationClient: ConfigurationClient,
  ) { }

  public configurationGet(useCancellationLogic: boolean | undefined = true): Observable<ConfigurationGetQueryResult> {
    if (useCancellationLogic && this.configurationGetSubscription != undefined) {
      this.configurationGetSubscription.unsubscribe();
    }

    return new Observable((observer: Observer<ConfigurationGetQueryResult>) => {
      this.configurationGetSubscription =
        this.configurationClient.configurationGet().subscribe(
          result => {
            observer.next(result);
            observer.complete();
          },
          error => {
            observer.error(error);
          }
        );
    });
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ConfigurationApiServiceProvider: Provider[] = [
  { provide: ConfigurationClient },
  { provide: IConfigurationApiServiceToken, useExisting: ConfigurationApiService }
];
